/*eslint no-undef: 0*/
import moreMenu from '../util/moreMenu';

export default {
  init() {
    // JavaScript to be fired on all pages
    moreMenu();

    function matchHeight() {
      $('.row, .mhwrap').each(function() {
        if($(window).width() > 1025) {
          var highestBox = 0;
          $(this).find('.mh').css("min-height", 0);
          $(this).find('.mh').each(function() {
            if ($(this).outerHeight() > highestBox) {
              highestBox = $(this).outerHeight();
            }
          });
          $(this).find('.mh').css("min-height", highestBox);
        }
      });
    }
    $(window).on("load resize", matchHeight).resize();

    if($('.banner__slider').length && $('.banner__slider__item').length > 1) {
      $('.banner__slider').flickity({
        contain: true,
        wrapAround: true,
        cellAlign: 'left',
        autoPlay: 4000,
        pageDots: false,
        arrowShape: {
          x0: 10,
          x1: 50, y1: 50,
          x2: 90, y2: 50,
          x3: 50,
        },
      });
      $(window).on('ready load', function() {
        $('.banner__slider').flickity('resize');
      });
    }

    if($('.location-single__image-slider').length && $('.location-single__image-slider__slide').length > 1) {
      $('.location-single__image-slider').flickity({
        contain: true,
        wrapAround: true,
        cellAlign: 'left',
        autoPlay: 4000,
        pageDots: false,
        arrowShape: {
          x0: 10,
          x1: 50, y1: 50,
          x2: 90, y2: 50,
          x3: 50,
        },
      });
      $(window).on('ready load', function() {
        $('.location-single__image-slider').flickity('resize');
      });
    }

    if($('.carousel-nav').length && $('.banner__slider__item').length > 1) {
      $('.carousel-nav').flickity({
        contain: true,
        cellAlign: 'left',
        pageDots: false,
        asNavFor: '.banner__slider',
        prevNextButtons: false,
        arrowShape: {
          x0: 10,
          x1: 50, y1: 50,
          x2: 90, y2: 50,
          x3: 50,
        },
      });
      $(window).on('ready load', function() {
        $('.carousel-nav').flickity('resize');
      });
    }

    if($('.carousel-nav__item').length >= 4 ) {
      $('.carousel-navbar').addClass('d-lg-block')
    } else {
      $('.carousel-navbar').addClass('d-lg-none')
    }

    if($('.agenda__slider').length && $('.agenda__slider__item').length > 1) {
      var wrap = false;
      var align;
      if($('.agenda__slider__item').length < 4) {
        align = 'center';
        wrap = false;
      } else {
        align = 'left';
        wrap = true;
      }
      var $carousel = $('.agenda__slider').flickity({
        pageDots: false,
        cellAlign: align,
        wrapAround: wrap,
        arrowShape: {
          x0: 10,
          x1: 50, y1: 50,
          x2: 90, y2: 50,
          x3: 50,
        },
      });

      var flkty = $carousel.data('flickity');
      $carousel.on( 'select.flickity', function() {
        var cellElements = $carousel.flickity('getCellElements').length;
        var prevDisabledCell;
        var nextDisabledCell;
        var index = 1;

        if($('.agenda__slider__item').length >= 4) {
          if ($(window).width() > 1025) {
            index = 2;
          }

          $('#agenda__carousel').removeClass('offset-lg-1');
          $('#agenda__carousel').addClass('offset-sm-2').addClass('offset-lg-3');
          $('.agenda__slider').addClass('cellWrap');
        } else {
          $('#agenda__carousel').removeClass('offset-sm-2').removeClass('offset-lg-3');
          $('#agenda__carousel').addClass('offset-lg-1');
          $('.agenda__slider').removeClass('cellWrap');
        }

        if(flkty.selectedIndex == 0) {
          prevDisabledCell = $carousel.flickity('getCellElements')[cellElements];
        } else {
          prevDisabledCell = $carousel.flickity('getCellElements')[flkty.selectedIndex - index];
        }

        if(flkty.selectedIndex >= cellElements - index) {
          nextDisabledCell = $carousel.flickity('getCellElements')[flkty.selectedIndex - cellElements + index];
        } else {
          nextDisabledCell = $carousel.flickity('getCellElements')[flkty.selectedIndex + index];
        }

        $carousel.find('.disabled').removeClass('disabled');
        $(prevDisabledCell).addClass('disabled');
        $(nextDisabledCell).addClass('disabled');
      });

      $(window).on('ready load', function() {
        $('.agenda__slider').flickity('resize');
      });
    }

    $(".reservationForm").on("click", function () {
      const widget = $("#gp-mc22ux6f-widget-container");
    
      if (widget.hasClass("gp-mc22ux6f-popup__closed")) {
        widget.removeClass("gp-mc22ux6f-popup__closed").addClass("gp-mc22ux6f-popup__open");
      } else if (widget.hasClass("gp-mc22ux6f-popup__open")) {
        widget.removeClass("gp-mc22ux6f-popup__open").addClass("gp-mc22ux6f-popup__closed");
      }
    });

    $(".ishopform").on("click", function() {
      $("#iShopForm").modal('show');
    });

    $(".close").on("click", function() {
      $("#iShopForm").modal('hide');
    });
    //resize iShopForm
    window.addEventListener("message",function(e){if(e.data[0]==="setResengoFrameHeight"){document.getElementById("ResengoFrame").style.height=e.data[1]+"px"}},false);


      $.fn.vmdIframe = function( options ) {
          var self = this;
          var settings = $.extend({
              classBtn: '.vmd-modalButton',
              defaultW: 640,
              defaultH: 360,
          }, options );

          $(settings.classBtn).on('click', function() {
            var allowFullscreen = $(this).attr('data-vmdVideoFullscreen') || false;

            var dataVideo = {
              'src': $(this).attr('data-vmdSrc'),
              'height': $(this).attr('data-vmdHeight') || settings.defaultH,
              'width': $(this).attr('data-vmdWidth') || settings.defaultW,
            };

            if ( allowFullscreen ) dataVideo.allowfullscreen = "";

            // stampiamo i nostri dati nell'iframe
            $(self).find("iframe").attr(dataVideo);
          });

          // se si chiude la modale resettiamo i dati dell'iframe per impedire ad un video di continuare a riprodursi anche quando la modale è chiusa {{-- @TODO: Hekkie? --}}
          this.on('hidden.bs.modal', function(){
            $(this).find('iframe').html("").attr("src", "");
          });

          return this;
      };

  jQuery(document).ready(function(){
    jQuery("#videoModal").vmdIframe();
  });

    //new WOW().init();
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    $(".nav-toggle").click(function(event) {
        var scrollHeight = $(window).scrollTop();
        $(".nav-wrapper, .nav-toggle, body").toggleClass("open");
        event.preventDefault();
        if($('.nav-toggle').hasClass('open')) {
          $('.nav-toggle').attr('data-height', scrollHeight);
        } else {
          $(window).scrollTop($('.nav-toggle').attr('data-height'));
        }
    });
    $(window).on("resize", function() {
      if($('.nav-toggle').hasClass('open')) {
        $(".nav-wrapper, .nav-toggle, body").removeClass("open");
      }
    });


    $('a[href^="tel:"]').click(function(e) {
      if(! /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        e.preventDefault();
      }
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js